export default __webpack_public_path__ + "static/media/closed.62ae28ce.png";